import { ColumnDetails } from '../../_models/profile/clf-profile/clfProfile.model';

export interface QuarterOption {
    quarterLabel: string;
    quarterValue: number;
}

export interface YearOption {
    yearValue: string;
    yearLabel: string;
    prevYearValue?: string;
}

export const QUARTER_DROP_DOWN_DATA: QuarterOption[] = [
    { quarterLabel: 'April-June', quarterValue: 1 },
    { quarterLabel: 'July-Sep', quarterValue: 2 },
    { quarterLabel: 'Oct-Dec', quarterValue: 3 },
    { quarterLabel: 'Jan-March', quarterValue: 4 },
];

export const getCurrentQuarter = (): number => {
    const month = new Date().getMonth() + 1;
    if (month >= 4 && month <= 6) return 1;
    if (month >= 7 && month <= 9) return 2;
    if (month >= 10 && month <= 12) return 3;
    return 4;
};

export const getDefaultQuarter = (): number => {
    const current = getCurrentQuarter();
    return current === 4 ? 3 : current;
};

export function getYearDropDownData(): YearOption[] {
    const financialYearOptions: YearOption[] = [];
    const currentYear = new Date().getFullYear();
    const currentQuarter = getCurrentQuarter();

    const startYear =
        currentQuarter === 4 || currentQuarter === 1
            ? currentYear - 1
            : currentYear;

    for (let i = startYear; i >= 2024; --i) {
        const yearString = i.toString();
        const lastTwoDigit = yearString.slice(2, 4);
        const nextYear = parseInt(lastTwoDigit) + 1;
        const prevYear = i - 1;
        const prevYearString = prevYear.toString();
        const prevLastTwoDigit = prevYearString.slice(2, 4);

        financialYearOptions.push({
            yearValue: `${yearString}${nextYear}`,
            yearLabel: `${yearString}-${nextYear}`,
            prevYearValue: `${prevYearString}${parseInt(prevLastTwoDigit) + 1}`,
        });
    }

    return financialYearOptions;
}

export const MAX_AAJEEVIKA_INCOME = 500000;

export const AAJEEVIKA_STATUS_MAP: Record<string, number> = {
    Approved: 6,
    Pending: 1,
    Reconsideration: 7,
    Rejected: 3,
};

export const AAJEEVIKA_STATUS_LIST = [
    'Approved',
    'Pending',
    'Reconsideration',
    'Rejected',
];

export const AAJEEVIKA_MEMBER_LIST_COLUMNS: ColumnDetails[] = [
    { field: 'select', label: '', sort: false },
    { field: 'memberName', label: 'memberName', sort: true, custom: true },
    { field: 'shgName', label: 'shgName', sort: true },
    { field: 'netIncome', label: 'netIncome', sort: true },
    {
        field: 'livelihoodCategories',
        label: 'livelihoodCategories',
        sort: true,
    },
    { field: 'expenditure', label: 'expenditure', sort: true },
    { field: 'approvalStatus', label: 'status', sort: true },
    { field: 'action', label: 'action', sort: false },
];

export const AAJEEVIKA_MEMBER_REPORT_HEADERS: Record<string, string> = {
    sNo: 'S.No.',
    panchayatName: 'Gram Panchayat',
    villageName: 'Village',
    shgName: 'SHG Name',
    memberName: 'Member Name',
    livelihoodCategories: 'Livelihood Categories',
    quarter: 'Quarter',
    netIncome: 'Net Income(₹)',
    expenditure: 'Expenditure(₹)',
    approvalStatus: 'Approval Status',
};

export const LOAN_TABLE_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: true },
    { field: 'fundingType', label: 'fundingType', sort: true },
    { field: 'loanType', label: 'fundType', sort: true },
    { field: 'loanSource', label: 'fundSource', sort: true },
    { field: 'amount', label: 'amount', sort: true },
];

export const ANIMAL_HUSBANDRY_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'typeOfAnimals', label: 'animalType', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const AQUA_FARMING_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'aquaFarmingType', label: 'Aqua Farming Type', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const CROP_BASED_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'areaUnit', label: 'areaUnit', sort: false },
    { field: 'season', label: 'season', sort: false },
    { field: 'cropName', label: 'cropName', sort: false },
    { field: 'totalProduction', label: 'totalProduction', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const NTFP_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    {
        field: 'livelihoodActivitySource',
        label: 'livelihoodActivity',
        sort: false,
    },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const MANUFACTURING_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'sector', label: 'sector', sort: false },
    { field: 'category', label: 'category', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const TRADING_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'sector', label: 'sector', sort: false },
    { field: 'category', label: 'category', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const SERVICES_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'sector', label: 'sector', sort: false },
    { field: 'category', label: 'category', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const WAGES_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'workCategory', label: 'workCategory', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const REGULAR_SOURCES_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'incomeSource', label: 'incomeSource', sort: false },
    { field: 'netIncome', label: 'netIncome', sort: false },
    { field: 'expenditure', label: 'expenditure', sort: false },
    { field: 'action', label: 'action', sort: false },
];

export const LIVELIHOOD_COLUMN_MAP: Record<string, ColumnDetails[]> = {
    'Animal Husbandry': ANIMAL_HUSBANDRY_COLUMNS,
    'Aqua Farming': AQUA_FARMING_COLUMNS,
    'Crop Based': CROP_BASED_COLUMNS,
    NTFP: NTFP_COLUMNS,
    Manufacturing: MANUFACTURING_COLUMNS,
    Trading: TRADING_COLUMNS,
    Services: SERVICES_COLUMNS,
    Wages: WAGES_COLUMNS,
    'Regular Sources': REGULAR_SOURCES_COLUMNS,
};

export const monthsDropdownData = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
];

export const AAJEEVIKA_EPDT_LIST_COLUMN = [
    'srNo',
    'shgName',
    'memberName',
    'memberId',
    'submissionDate',
    'lastUpdatedDate',
    'aajeevikaIncome',
    'totalExpectedIncome',
    'status',
    'action',
];

export const AAJEEVIKA_EPDT_STATUS_REVERSE_MAP: Record<number, string> = {
    0: 'Open',
    1: 'Pending',
    3: 'Rejected',
    6: 'Approved',
    7: 'Reconsideration',
};

export const AAJEEVIKA_EPDT_TABLE_COLUMNS: ColumnDetails[] = [
    { field: 'index', label: 'sNo', sort: false },
    { field: 'shgName', label: 'shgName', sort: true },
    { field: 'shgMemberName', label: 'memberName', sort: true },
    { field: 'memberId', label: 'memberId', sort: true },
    { field: 'submittedAt', label: 'submissionDate', sort: true, custom: true },
    {
        field: 'updatedDate',
        label: 'lastUpdatedDate',
        sort: true,
        custom: true,
    },
    {
        field: 'totalAajeevikaIncome',
        label: 'aajeevikaIncome',
        sort: true,
        custom: true,
    },
    {
        field: 'totalExpectedIncome',
        label: 'totalExpectedIncome',
        sort: true,
        custom: true,
    },
    { field: 'status', label: 'status', sort: false, custom: true },
    { field: 'action', label: 'action', sort: false },
];

export const FINANCE_FUNDING_COLUMNS: ColumnDetails[] = [
    { field: 'livelihoodActivity', label: 'livelihoodActivity', sort: true },
    { field: 'fundingType', label: 'supportCategory', sort: true },
    { field: 'loanSource', label: 'capitalSource', sort: true },
    { field: 'loanType', label: 'typeOfCapital', sort: true },
    { field: 'amount', label: 'amount', sort: true },
    { field: 'ownContribution', label: 'ownContribution', sort: true },
];

export const ASSET_TABLE_COLUMNS: ColumnDetails[] = [
    { field: 'livelihoodActivity', label: 'livelihoodActivity', sort: true },
    { field: 'assetName', label: 'assetName', sort: true },
    { field: 'assetType', label: 'assetType', sort: true },
    { field: 'statusOfAsset', label: 'statusOfAsset', sort: true },
    { field: 'procurementSource', label: 'procurementSource', sort: true },
    { field: 'estimatedCost', label: 'estimatedCost', sort: true },
];

export const TRAINING_TABLE_COLUMNS: ColumnDetails[] = [
    { field: 'livelihoodActivity', label: 'livelihoodActivity', sort: true },
    { field: 'trainingName', label: 'trainingName', sort: true },
    { field: 'trainingSource', label: 'trainingSource', sort: true },
    { field: 'durationInDays', label: 'durationInDays', sort: true },
];

export const CROP_PARTICULARS = [
    { key: 'seedsAndOtherInputCost', label: 'Seeds & Other Inputs' },
    {
        key: 'fieldAndIntercultureCost',
        label: 'Field Preparation & Interculate operations costs',
    },
    { key: 'fertilizerCost', label: 'Fertilizer Cost' },
    { key: 'insectPestCost', label: 'Insect Pest Cost' },
    { key: 'irrigationCost', label: 'Irrigation Cost' },
    { key: 'labourCost', label: 'Labour Cost' },
    { key: 'otherCost', label: 'Other Cost' },
];
